import z from 'zod';

export const wrapDjangoPaginationList = <T extends z.ZodType>(results: T) =>
  z.object({
    count: z.number(),
    next: z.number().nullable(),
    previous: z.number().nullable(),
    results: results as T,
  });
